export interface DateRangePickerValue {
  dateRange: [Date, Date];
  hasTime: boolean;
}
